import e from "react";
import { AppLauncherItem as a } from "./AppLauncherItem.js";
import n from "../../../../node_modules/classnames/index.js";
function r(r) {
  var t = r.apps,
    c = r.header,
    l = n(r.className, "launcher-panel__section");
  return (null == t ? void 0 : t.length) ? e.createElement("div", {
    className: l
  }, e.createElement("div", {
    className: "launcher-panel__section-header"
  }, c), e.createElement("div", {
    className: "launcher-panel__section-body"
  }, t.map(function (n) {
    return e.createElement(a, {
      key: n.productId,
      app: n
    });
  }))) : null;
}
r.displayName = "AppLauncherPanelSection";
export { r as AppLauncherPanelSection };